module.exports = __webpack_public_path__ + "0b48f72fa2f3acb92464259899661b7e.svg";